module.exports = __webpack_public_path__ + "img/user-19.2f20ae28.svg";